var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1344 18)",
    fill: "#f58181",
    opacity: 0.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1344 -18)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20831.564-1604.554a13.253,13.253,0,0,0-2.592-3.6,11.936,11.936,0,0,0-8.594-3.6,11.936,11.936,0,0,0-8.594,3.6,13.2,13.2,0,0,0-2.592,3.6.745.745,0,0,0-.064.3.744.744,0,0,0,.064.3,13.256,13.256,0,0,0,2.592,3.6,11.938,11.938,0,0,0,8.594,3.594,11.938,11.938,0,0,0,8.594-3.594,13.256,13.256,0,0,0,2.592-3.6.744.744,0,0,0,.064-.3A.745.745,0,0,0-20831.564-1604.554Zm-11.186,6.3a10.327,10.327,0,0,1-7.494-3.117,12.535,12.535,0,0,1-2.162-2.883,12.529,12.529,0,0,1,2.162-2.883,10.327,10.327,0,0,1,7.494-3.117,10.327,10.327,0,0,1,7.494,3.117,12.482,12.482,0,0,1,2.166,2.883C-20833.766-1602.988-20836.709-1598.25-20842.75-1598.25Zm0-10.5a4.5,4.5,0,0,0-2.5.758,4.508,4.508,0,0,0-1.658,2.02,4.5,4.5,0,0,0-.256,2.6,4.506,4.506,0,0,0,1.232,2.3,4.5,4.5,0,0,0,2.3,1.231,4.5,4.5,0,0,0,2.6-.256,4.5,4.5,0,0,0,2.02-1.657,4.5,4.5,0,0,0,.758-2.5,4.508,4.508,0,0,0-1.32-3.181A4.5,4.5,0,0,0-20842.75-1608.75Zm0,7.5a2.993,2.993,0,0,1-1.666-.506,2.993,2.993,0,0,1-1.105-1.346,2.992,2.992,0,0,1-.17-1.733,2.992,2.992,0,0,1,.82-1.536,3,3,0,0,1,1.535-.821,3,3,0,0,1,1.734.171,3.008,3.008,0,0,1,1.346,1.1,3,3,0,0,1,.506,1.667,3,3,0,0,1-.879,2.121A3,3,0,0,1-20842.75-1601.25Z",
    transform: "translate(22199 1634)",
    fill: "rgba(0,0,0,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordToggleIcon);
export default __webpack_public_path__ + "static/media/password-toggle-icon.72dfa900575ff55fcc5193accde672bb.svg";
export { ForwardRef as ReactComponent };